import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

import EditableCheckbox from '../../../components/forms/EditableCheckbox';
import AddressInput from '../../../components/forms/AddressInput';
import LayoutImageUpload from '../../../components/forms/LayoutImageUpload';
import Input from 'components/forms/LayoutInput';
import LayoutRadioGroup from '../../../components/forms/LayoutRadioGroup.jsx';

import ToolTip, {tooltipPositions} from '../../../components/ToolTip.jsx';
import Row from '../../../components/Row';
import Col from '../../../components/Col';
import {FormattedMessage} from 'react-intl';
import phoneFormat from '../../../helpers/phoneFormat';
import {isValidPhone, isValidEmail, isValidURL} from '../../../helpers/validation';

class LeftColumn extends PureComponent {
  getImage() {
    return this.upload.getImage();
  }

  clear() {
    return this.upload.clear();
  }

  render() {
    const {edit, store, onEdit, changeOverride, formatMessage} = this.props;

    return <Row>
      <Col md={12}>
        <LayoutImageUpload edit={edit && store.overrideBranding} image={store.logoLink} setEdit={onEdit}
                           ref={upload => this.upload = upload}/>
      </Col>
      <Col md={12}>
        <EditableCheckbox label={formatMessage({id: 'preferences.store.logo.description'})} editMode={edit}
                          onChange={changeOverride} dataKey='overrideBranding' value={!store.overrideBranding}/>
      </Col>
    </Row>;
  }
}

LeftColumn.propTypes = {
  edit: PropTypes.bool.isRequired,
  store: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  changeOverride: PropTypes.func.isRequired,
  formatMessage: PropTypes.any,
};

class RightColumn extends PureComponent {

  /**
   *
   * @returns {*}
   */
  render() {
    const {edit, store, onChange, group, dealer, useEmailValidation, formatMessage} = this.props;

    return <Row>
      <Col sm={12}>
        <Input label={formatMessage({id: 'preferences.store.name'})} dataKey='brandingName' value={store.brandingName}
               disabled={!store.overrideBranding}
               editMode={edit} dataChanged={onChange} group={group}/>
      </Col>
      <Col sm={6}>
        <AddressInput onChange={onChange} edit={edit} obj={store} group={group} country={dealer.country || 'US'}/>
      </Col>
      <Col sm={6}>
        <Input label={formatMessage({id: 'general.phone.number'})}
               dataKey='phone'
               key='phone'
               value={store.phone}
               format={phoneFormat}
               required={true}
               validate={isValidPhone}
               validateMessage={<FormattedMessage id='general.phone.validation'/>}
               editMode={edit}
               dataChanged={onChange}
               group={group}/>
        <Input label={formatMessage({id: 'general.email'})} dataKey='email' value={store.email} key='email'
               validate={isValidEmail}
               validateMessage={<FormattedMessage id='general.email.validation'/>} required={true}
               editMode={edit} dataChanged={onChange} group={group}/>
      </Col>
      <Col sm={12}>
        <Input label={formatMessage({id: 'general.website'})} dataKey='website' value={store.website} key='website'
               validate={isValidURL} validateMessage={<FormattedMessage id='general.website.validation'/>}
               editMode={edit} dataChanged={onChange} group={group}/>
      </Col>
      <Col sm={12}>
        {edit ?
          <LayoutRadioGroup label={formatMessage({id: 'preferences.store.reply.email'})}
                            options={[
                              formatMessage({id: 'preferences.store.email.preferences'}),
                              formatMessage({id: 'preferences.store.email.default'}, {defaultEmail: 'noreply@bioguard.com'}),
                            ]}
                            dataKey='useEmail' inline={true} colSizes={[5, 7]}
                            value={store.useEmail.toString()} keys={['true', 'false']} onChange={onChange}
                            onClick={useEmailValidation}/> :
          store.useEmail ?
            <div><label><FormattedMessage id="preferences.store.reply.address"/></label>
              <div>{store.email}</div>
            </div> :
            <div><label><FormattedMessage id="preferences.store.reply.address"/></label>
              <div>noreply@bioguard.com</div>
            </div>
        }
      </Col>
    </Row>;
  }
}

RightColumn.propTypes = {
  edit: PropTypes.bool,
  store: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  group: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
  useEmailValidation: PropTypes.func,
  formatMessage: PropTypes.any,
};

class StoreInfo extends PureComponent {
  getImage() {
    return this.left.getImage();
  }

  clear() {
    return this.left.clear();
  }

  render() {
    const {store, edit, changeOverride, onEdit, group, onChange, dealer, useEmailValidation, formatMessage} = this.props;

    return <div className='settings-page'>
      <h2 className='with-keyline'><FormattedMessage id="customer.contact.information"/>
        <ToolTip title={formatMessage({id: 'preferences.store.customer.tooltip'})}
                 position={tooltipPositions.topLeft} style={{float: 'right'}}/>
      </h2>
      <Row>
        <Col md={5}>
          <LeftColumn edit={edit} store={store} onEdit={onEdit} changeOverride={changeOverride}
                      ref={left => this.left = left} formatMessage={formatMessage}/>
        </Col>
        <Col md={7}>
          <RightColumn edit={edit} store={store} onChange={onChange} group={group} dealer={dealer}
                       useEmailValidation={useEmailValidation} formatMessage={formatMessage}/>
        </Col>
      </Row>
    </div>;
  }
}

StoreInfo.propTypes = {
  edit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
  changeOverride: PropTypes.func.isRequired,
  useEmailValidation: PropTypes.func,
  formatMessage: PropTypes.any,
};

export default StoreInfo;
